'use client';

interface IIconProps {
    className?: string;
    onClick?: () => void;
    onKeyDown?: (event: React.KeyboardEvent) => void;
    'aria-label'?: string;
    role?: string;
    tabIndex?: number;
}

export function IconClose({ className, ...rest }: IIconProps): React.ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            className={className}
            fill="currentColor"
            aria-hidden={rest['aria-label'] ? undefined : true}
            {...rest}
        >
            <path d="M18.3 5.71 12 12l6.3 6.29-1.42 1.42L10.59 13.41 4.29 19.71 2.88 18.3 9.17 12 2.88 5.71 4.29 4.3l6.3 6.29L16.88 4.3z" />
        </svg>
    );
}

export function IconCheck({ className }: IIconProps): React.ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            className={className}
            fill="currentColor"
            aria-hidden
        >
            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
    );
}

/** Circle with an x, stroked, matching the opt-out error dialog. */
export function IconCircleX({ className }: IIconProps): React.ReactElement {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 33 33"
            width="1em"
            height="1em"
            fill="none"
            className={className}
            aria-hidden
        >
            <path
                d="M21 12L12 21M12 12L21 21M31.5 16.5C31.5 24.7843 24.7843 31.5 16.5 31.5C8.21573 31.5 1.5 24.7843 1.5 16.5C1.5 8.21573 8.21573 1.5 16.5 1.5C24.7843 1.5 31.5 8.21573 31.5 16.5Z"
                stroke="#DC2626"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

/** Outline circle-check exported from the opt-out success dialog in Figma. */
export function IconCircleCheck({ className }: IIconProps): React.ReactElement {
    return (
        <svg
            viewBox="0 0 36 36"
            width="1em"
            height="1em"
            fill="none"
            className={className}
            aria-hidden
        >
            <path
                d="M18 3.375C12.7266 3.375 7.94531 6.1875 5.27344 10.6875C2.67188 15.2578 2.67188 20.8125 5.27344 25.3125C7.94531 29.8828 12.7266 32.625 18 32.625C23.2031 32.625 27.9844 29.8828 30.6562 25.3125C33.2578 20.8125 33.2578 15.2578 30.6562 10.6875C27.9844 6.1875 23.2031 3.375 18 3.375ZM18 36C11.5312 36 5.625 32.625 2.39062 27C-0.84375 21.4453 -0.84375 14.625 2.39062 9C5.625 3.44531 11.5312 0 18 0C24.3984 0 30.3047 3.44531 33.5391 9C36.7734 14.625 36.7734 21.4453 33.5391 27C30.3047 32.625 24.3984 36 18 36ZM25.9453 14.6953L16.9453 23.6953C16.2422 24.3984 15.1875 24.3984 14.5547 23.6953L10.0547 19.1953C9.35156 18.5625 9.35156 17.5078 10.0547 16.875C10.6875 16.1719 11.7422 16.1719 12.4453 16.875L15.75 20.1797L23.5547 12.375C24.1875 11.6719 25.2422 11.6719 25.9453 12.375C26.5781 13.0078 26.5781 14.0625 25.9453 14.6953Z"
                fill="#16A34A"
            />
        </svg>
    );
}

export function IconCopy({ className }: IIconProps): React.ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            className={className}
            fill="currentColor"
            aria-hidden
        >
            <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
        </svg>
    );
}

export function IconGlobe({ className }: IIconProps): React.ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            className={className}
            fill="currentColor"
            aria-hidden
        >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
        </svg>
    );
}
